// @ts-nocheck

import memoize from 'memoize-state';
import React from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import GridsPublicCta from '../../components/public/GridsPublicCta';
import { getPublicCta } from '../../selectors/public';

const legacySelector = memoize(getPublicCta);

type GridsPublicCtaContainerProps = {
  className?: string;
  gridReference: string | null;
};

const GridsPublicCtaContainer = (ownProps: GridsPublicCtaContainerProps) => {
  const { gridReference } = ownProps;

  const selectedProps = useSelector((state) => legacySelector(state, { gridReference }));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <GridsPublicCta {...enhancedProps} />;
};

export default GridsPublicCtaContainer;
